export enum Role {
  COMPANY_ADMIN = "company_admin",
  OWL_WAREHOUSE = "owl_warehouse",
  OWL_CARRIER = "owl_carrier",
}
